module.exports = __webpack_public_path__ + "img/stevens-park.90c9396d.jpeg";